export default function ContentWrapper({ children }: { children: React.ReactNode }) {
    return (
        <div className="mx-auto -mt-8 ">
            <div className="w-full max-w-7xl mx-auto p-5 bg-white rounded-md shadow-md flex flex-col space-y-5">
                {children}
            </div >
        </div>
    )
}
